<template>
  <main class="substitutions">
    <header>Select a value to substitute</header>
    <div
      class="substitution"
      v-for="sub in substitutions"
      @click="clickedSubstitution(sub)"
      :data-cy="dataCy(sub.label)"
    >
      {{ sub.label }}
    </div>
  </main>
</template>

<script>
export default {
  name: "substitutions",
  props: {
    substitutions: Array
  },

  methods: {
    clickedSubstitution(sub) {
      this.$emit('updated:substitution', sub);
    },
    dataCy(sub){
      return `substitution-${sub.replaceAll(' ','-')}`
    }
  }
}
</script>

<style scoped>
  .substitutions {
    padding: 10px;
  }
  .substitution {
    cursor: pointer;
    margin: 5px 0;
    color: #128ff9;
  }
</style>
